import { createContext } from "react";

export const EditorContext = createContext({
  updateContent: () => {},
  updateComponent: () => {},
  updateComponentStyle: () => {},
  addThisAfterThat: () => {},
});
